import { inject, Injectable } from '@angular/core';
import { ApiService } from './api-service';
import { PagingResponse, SiteSummary } from '../models/cms-models';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  private apiService = inject(ApiService);

  async getSites(): Promise<SiteSummary[]> {
    const response = await this.apiService.get<PagingResponse<SiteSummary>>('api/site');
    return response.data;
  }

  async getSite(id: string): Promise<SiteSummary> {
    return this.apiService.get<SiteSummary>(`api/site/${id}`);
  }

  async createSite(name: string): Promise<SiteSummary> {
    return this.apiService.post<SiteSummary, { name: string }>('api/site', { name });
  }

  async updateSite(id: string, name: string): Promise<SiteSummary> {
    return this.apiService.put<SiteSummary, { name: string }>(`api/site/${id}`, { name });
  }

  async deleteSite(id: string): Promise<void> {
    await this.apiService.delete(`api/site/${id}`);
  }
}
